
const fanlistings = [
    {
        title: "mouthwashing",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/mouthwashing.png',
        url: "https://mouthwashinggame.neocities.org/"
    },
    {
        title: "millenium actress",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/ma.png',
        url: "https://ma.lost-boy.org/"
    },
    {
        title: "perfect blue",
       thumbnail:process.env.PUBLIC_URL+ './images/webrings/pb.gif',
        url: "https://perfectblue.anime.nu/"
    },
    {
        title: "no6",
       thumbnail:process.env.PUBLIC_URL+ './images/webrings/no6.gif',
        url: "https://fan.shinshoku.net/no6/"
    },
    {
        title: "nana",
       thumbnail:process.env.PUBLIC_URL+ './images/webrings/nana.png',
        url: "https://fan.enamour.nu/nana/"
    },
    {
        title: "madoka",
       thumbnail:process.env.PUBLIC_URL+ './images/webrings/madoka.png',
        url: "https://fan.after-death.org/magica/"
    },
    {
        title: "vocaloid",
       thumbnail:process.env.PUBLIC_URL+ './images/webrings/vocaloid.png',
        url: "https://fanlistings.melankorin.net/vocaloid/"
    },
    {
        title: "yona",
       thumbnail:process.env.PUBLIC_URL+ './images/webrings/yona.png',
        url: "https://fan.midnight-cloud.net/dawn/"
    },
    {
        title: "bloodborne",
       thumbnail:process.env.PUBLIC_URL+ './images/webrings/bloodborne.png',
        url: "https://fan.winterlantern.net/bloodborne/"
    },
    {
        title: "hakuouki",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/hakuoki.png',
        url: "https://firaga.org/hakuouki/"
    },
    {
        title: "parasite eve",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/parasiteeve.gif',

        url: "http://fan.asuka.nu/pe/"
    },
    {
        title: "aya",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/aya.png',

        url: "https://fan.enamour.nu/aya/"
    },
    {
        title: "ff13",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/vanille.png',

        url: "https://xiii.redcrown.net/"
    },
        {
        title: "alisaie",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/alisaie.gif',

        url: "http://www.celes.net/alisaie/"
    },
        {
         title: "shb",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/ryne.png',

        url: "https://shb.crystarium.net"
    },
            {
         title: "venat",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/venat.png',
        url: "https://firaga.org/venat/"
    },
    {
         title: "estinien",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/estinien.png',
        url: "https://drg.ishgard.org"
    },
    {
         title: "bg3",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/shadowheart.png',
        url: "https://glitterskies.org/bg3/"
    },
    {
        title: "charmed",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/charmed.png',
        url: "https://charmed.altervista.org/show/"

    },
    {
        title: "rin tohsaka",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/rin.jpg',
        url: "https://www.marheavenj.net/sorcerer"

    },
    {
        title: "ysayle",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/ysayle.png',
        url: "https://firaga.org/iceheart"

    },
    {
        title: "chrom",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/chrom.gif',
        url: "https://chrom.reflet.org"

    },
    {
        title: "tma",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/tma_tape_recorder_50x50.png',
        url: "https://aureatecorvidarchives.com/fanlistings/themagnusarchives/"

    },
    {
        title: "stp",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/stp.png',
        url: "https://woods.calicocafe.xyz/"

    },
        {
        title: "tlt",
        thumbnail:process.env.PUBLIC_URL+ './images/webrings/tlt.png',
        url: "https://shadow-lord.com/locked/"

    }

]

export default fanlistings;